export function formatToSSN(value: string): string {
  return value
    .replace(/[^\dx]/g, "")
    .replace(/^(\w{3})/, "$1-")
    .replace(/-(\w{2})/, "-$1-")
    .replace(/(\w)-(\w{4}).*/, "$1-$2");
}
